import { Bed, I18n } from "@intocare/interfaces";

export const bedTypes = [
	{
		name: {
			nl: "ROB",
			fr: "MRPA",
		},
		type: Bed.ROB,
	},
	{
		name: {
			nl: "RVT",
			fr: "MRS",
		},
		type: Bed.RVT,
	},
	{
		name: {
			nl: "NO",
			fr: "NO",
		},
		type: Bed.NO,
	},
	{
		name: {
			nl: "CVK",
			fr: "CS",
		},
		type: Bed.CVK,
	},
];

export const bedTypesMap = new Map<Bed, I18n>(bedTypes.map((bedType) => [bedType.type, bedType.name] as [Bed, I18n]));
